import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export const SCHEDULING_INFO_HEIGHT = 58;

export default makeStyles((theme: MuiTheme) => ({
  component: {
    background: "#f6fbfa",
    flex: 1,
    width: "100%",
    paddingTop: 24,
    paddingLeft: 0,
    paddingRight: 0,
    position: "relative",
    height: "100%",
    paddingBottom: 70
  },
  pageHeader: {
    height: 195
  },
  appPageHeader: {
    height: "initial"
  },
  schedulingInfo: {
    height: SCHEDULING_INFO_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 24,
    paddingRight: 24,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 16,
      paddingRight: 16
    },
    "& .MuiTypography-root": {
      fontSize: 14,
      lineHeight: "normal"
    }
  },
  schedulingDates: {
    whiteSpace: "nowrap"
  },
  footer: {
    boxShadow: "3px 0px 7px 0px rgba(0, 0, 0, 0.15)",
    background: "white",
    zIndex: 2
  },
  virtualListContainer: {
    overflowX: "hidden"
  },
  listVirtualized: {
    width: "100%"
  },
  autoSizerContainer: {
    display: "grid",
    height: "100%"
  },
  appPageTableContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  appPageTableContentCondensed: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    flex: "auto"
  },
  workoutsContainer: {
    overflowY: "auto",
    overflowX: "hidden"
  }
}));
